// extracted by mini-css-extract-plugin
export default {"tab":"SimulationArgsTab_tab__e3spu"};